/** Local-only evidence: an explicit send completed on this mounted chat visit. */
export type ReviewActivity = { token: object; path: string; phase: 'start' | 'finish'; successful: boolean };
const listeners = new Set<(event: ReviewActivity) => void>();
export function onReviewActivity(listener: (event: ReviewActivity) => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
export function beginReviewActivity(path: string): (successful: boolean) => void {
  const token = {};
  for (const listener of listeners) listener({ token, path, phase: 'start', successful: false });
  let finished = false;
  return successful => {
    if (finished) return;
    finished = true;
    for (const listener of listeners) listener({ token, path, phase: 'finish', successful });
  };
}
